/**
 * Utility functions for managing document metadata, title, and manifest
 */

/**
 * Default dependencies - can be overridden for testing
 */
const defaultDependencies = {
    document: typeof document !== 'undefined' ? document : null,
};

/**
 * Sets the document title and meta description
 * @param {string} productName - The product name to use in title and description
 * @param {Object} deps - Dependencies object for testing
 */
export const setDocumentTitleAndMeta = (productName, deps = defaultDependencies) => {
    const { document } = deps;
    
    document.title = `NetApp ${productName}`;

    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
        meta = document.createElement('meta');
        meta.name = "description";
        document.head.appendChild(meta);
    }
    meta.content = `NetApp ${productName}`;
};

/**
 * Factory function to create a DocumentUtils instance with injected dependencies
 * Useful for testing and different environments
 * @param {Object} customDeps - Custom dependencies to override defaults
 * @returns {Object} - Object with all utility functions bound to the dependencies
 */
export const createDocumentUtils = (customDeps = {}) => {
    const deps = { ...defaultDependencies, ...customDeps };
    
    return {
        setDocumentTitleAndMeta: (productName) => setDocumentTitleAndMeta(productName, deps),
    };
};
